module.exports = __webpack_public_path__ + "static/media/history-redo.40856abb.svg";